import React from 'react'

export const ShowCaseHorizontal = () => {
    return (
        <div className="user__showcase__horizontal mb-3">
            <img src="/assets/images/projects/33.jpg" alt="" className="project-cover" />
            <div>
                <img src="/assets/images/faces/1.png" alt="" className="project-logo" />
            </div>
            <div><p>@author</p></div>
            <p> Authority is the largest mobile commerce company in Egypt</p>
        </div>
    )
}
